import { motion } from "framer-motion";

const GeometricCheckbox = () => {
  return (
    <div
      style={{
        cursor: "pointer",
        display: "inline-block",
        width: "60px",
        height: "60px",
      }}
    >
      <motion.svg width="60" height="60" viewBox="0 0 100 100">
        <motion.path
          d="M35 55 L45 65 L65 35"
          fill="none"
          stroke="#644980"
          strokeWidth="8"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        />
      </motion.svg>
    </div>
  );
};

export default GeometricCheckbox;
